export const ROOT_ELEMENT = 'h2'
